"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.procesVerbalSheet = void 0;
const utils_1 = require("../../utils");
exports.procesVerbalSheet = [
    {
        '@type': 'tristate',
        key: '88c390f0-a9e6-483e-abaf-569eca382076',
        label: 'La victime a refusé de décliner son identité',
        value: (bilan) => (0, utils_1.boolToChar)(bilan?.proces_verbals?.refus_identity),
    },
    {
        '@type': 'tristate',
        key: '4e8fd28e-6872-43d3-a056-61f34a86a7fa',
        label: "La victime a refusé de remplir et/ou de signer l'attestation de refus de soins et/ou de transport",
        value: (bilan) => (0, utils_1.boolToChar)(bilan?.proces_verbals?.refus_attestion_refus_soins_transport),
    },
    {
        '@type': 'tristate',
        key: '1a36e49b-862e-4eec-b6a1-16608c53a5bf',
        label: 'La victime a pris la fuite',
        value: (bilan) => (0, utils_1.boolToChar)(bilan?.proces_verbals?.escaped),
    },
    {
        '@type': 'table',
        key: '51b87334-be0a-43b2-9369-2bcb613ba5c2',
        label: 'Témoins',
        value: (bilan) => bilan?.proces_verbals?.temoins || [],
        template: 'TEMOINS',
    },
];
